export const config = {
  region: import.meta.env.VITE_REGION,
  userPoolId: import.meta.env.VITE_USER_POOL_ID,
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
  apiUrl: import.meta.env.VITE_API_URL,
  supportEmail: import.meta.env.VITE_SUPPORT_EMAIL ?? 'info@neosigma.com.au',
};

export function assertConfigured(): void {
  const missing = (['region', 'userPoolId', 'userPoolClientId', 'apiUrl'] as const).filter(
    (k) => !config[k],
  );
  if (missing.length) {
    // eslint-disable-next-line no-console
    console.warn(
      `[portal] missing VITE_* env vars: ${missing.join(', ')}. Create a .env.local based on .env.example.`,
    );
  }
}
